import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  OnChanges,
} from '@angular/core';
import {AppliedCouponsComponent} from '@spartacus/cart/base/components';
import {TemplateView} from '@app/model/template-view.model';
import {CartVoucherFacade, Voucher} from '@spartacus/cart/base/root';
import {DcpGlobalMessageService} from '@dcp/configurator';
import {UntilDestroy, untilDestroyed} from '@ngneat/until-destroy';
import {CartDecoratorErrorHandlingService} from '@app/checkout/services/cart-decorator-error-handling.service';
import {RefreshCartService} from '@app/checkout/services/refresh-cart.service';

@UntilDestroy()
@Component({
  selector: 'dcp-applied-coupons',
  templateUrl: './dcp-applied-coupons.component.html',
  styleUrls: ['./dcp-applied-coupons.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DcpAppliedCouponsComponent extends AppliedCouponsComponent implements OnInit, OnChanges {
  @Output() errorNoCoupon: EventEmitter<void> = new EventEmitter<void>();
  @Input() selectedView: TemplateView;
  view = TemplateView;
  notValidCouponsError: { isError: boolean, errorVouchers: Voucher[] } = {isError: false, errorVouchers: undefined};
  removeCoupon = false;

  constructor(
    protected cartVoucherService: CartVoucherFacade,
    public dcpGlobalMessageService: DcpGlobalMessageService,
    private cartDecoratorErrorHandlingService: CartDecoratorErrorHandlingService,
    private changeDetectorRef: ChangeDetectorRef,
    private refreshCartService: RefreshCartService
  ) {
    super(cartVoucherService);
  }

  removeVoucher(voucherId: string) {
    this.cartVoucherService.removeVoucher(voucherId);
    this.dcpGlobalMessageService.removeMessage(voucherId, 'appliedCouponsPromotions');
    this.removeCoupon = true;
  }

  ngOnInit() {
    this.subscribeToPromotionValidation();
  }

  /**
   * Updates applied vouchers section in case applied voucher is no longer actual per validation response
   *
   * @private
   */
  private subscribeToPromotionValidation() {
    this.cartDecoratorErrorHandlingService.promotionRemovedErrorSubject$
      .pipe(untilDestroyed(this))
      .subscribe(promotionRemovedValidationResult => {
          if (promotionRemovedValidationResult.showError) {
            this.notValidCouponsError = {
              isError: promotionRemovedValidationResult.showError,
              errorVouchers: this.sortedVouchers
            };
            if (!this.sortedVouchers?.length) {
              this.errorNoCoupon.emit();
            }
            this.refreshCartService.refreshCart();
            this.changeDetectorRef.detectChanges();
          }
        }
      );
  }

  ngOnChanges() {
    if (this.vouchers.length == 0) {
      this.removeCoupon = false;
    }
  }
}
